<template>
  <div
    class="level-card"
    :class="{ locked: locked }"
    @click="onCardClick"
  >
    <div class="image-container">
      <img
        :src="image"
        :alt="title"
      >
      <div
        v-if="locked"
        class="lock-overlay"
      >
        <span class="lock-icon">🔒</span>
      </div>
    </div>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: "LevelCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCardClick() {
      this.$emit("card-click");
    },
  },
};
</script>

<style scoped>
.level-card {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  background-color: #0099ff;
  color: white;
  transition: box-shadow 0.3s;
}

.level-card:hover {
  border: 1px solid #0099ff;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.4);
}

.image-container {
  position: relative;
  width: 100%;
  padding-top: 75%; /* 4:3 Aspect Ratio */
  overflow: hidden;
}

.image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.lock-icon {
  color: white;
  font-size: 48px;
}

.level-card.locked {
  opacity: 0.7;
}

.level-card h3 {
  margin: 10px 0;
  font-size: 28px;
}
</style>